<template>
  <v-avatar :class="{ 'avatar-border': isBorder }" :size="size" color="white">
    <img v-if="id" :style="style" v-bind:src="src" />
    <span v-else class="text-h6">{{ initials }}</span>
  </v-avatar>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
  name: "Avatar",
  props: {
    size: {
      type: Number,
      default: 48
    },
    id: {
      type: String
    },
    float: {
      type: String
    },
    borderColor: {
      type: String
    },
    user: {
      type: Object
    },
    isBorder: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    initials() {
      let initials = this.user.name.split(" ");

      if (initials.length > 1) {
        initials = initials.shift().charAt(0) + initials.pop().charAt(0);
      } else {
        initials = this.user.name.substring(0, 2);
      }

      return initials.toUpperCase();
    },
    style() {
      return {
        width: this.size + 4 + "px",
        height: this.size + 4 + "px",
        borderRadius: "10px !important",
        float: this.float ? this.float : "left",
        // marginRight: "10px",
        boxShadow:
          "0 " +
          Math.round(this.size * 0.1) +
          "px " +
          Math.round(this.size / 2) +
          "px 0 rgba(255,255,255,0.2)",
        border:
          "1px solid " +
          (this.borderColor ? this.borderColor : "rgba(0,0,0,.05)")
      };
    },
    src() {
      return "/avatar/" + this.id;
    }
  }
});
</script>
<style scoped>
.avatar-border {
  border: 2px solid white;
}
</style>
